import type { ButtonSize, ButtonVariant, TextVariant } from './tokens';

export const textVariantClass: Record<TextVariant, string> = {
  display: 'cs-text-display',
  h1: 'cs-text-h1',
  h2: 'cs-text-h2',
  h3: 'cs-text-h3',
  body: 'cs-text-body',
  'body-sm': 'cs-text-body-sm',
  caption: 'cs-text-caption',
  label: 'cs-text-label',
};

export const buttonVariantClass: Record<ButtonVariant, string> = {
  primary: 'cs-btn-primary',
  secondary: 'cs-btn-secondary',
  ghost: 'cs-btn-ghost',
  danger: 'cs-btn-danger',
};

export const buttonSizeClass: Record<ButtonSize, string> = {
  sm: 'cs-btn-sm',
  md: 'cs-btn-md',
  lg: 'cs-btn-lg',
};

export type BadgeVariant = 'neutral' | 'accent' | 'danger' | 'success' | 'warning';

export const badgeVariantClass: Record<BadgeVariant, string> = {
  neutral: 'cs-badge-neutral',
  accent: 'cs-badge-accent',
  danger: 'cs-badge-danger',
  success: 'cs-badge-success',
  warning: 'cs-badge-warning',
};
